import { render } from "./DeleteView.vue?vue&type=template&id=2b673700"
const script = {}

import "./DeleteView.vue?vue&type=style&index=0&id=2b673700&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__